import { render, staticRenderFns } from "./PNLSummaryReport.vue?vue&type=template&id=064bb92b&scoped=true&"
import script from "./PNLSummaryReport.vue?vue&type=script&lang=js&"
export * from "./PNLSummaryReport.vue?vue&type=script&lang=js&"
import style0 from "./PNLReport.scss?vue&type=style&index=0&id=064bb92b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064bb92b",
  null
  
)

/* custom blocks */
import block0 from "./PNLSummaryReport.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=https%3A%2F%2Funpkg.com%2Fbootstrap-vue%40latest%2Fdist%2Fbootstrap-vue.min.css"
if (typeof block0 === 'function') block0(component)

export default component.exports